import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon";
export default function RotateCCW(props) {
    return (_jsxs(Icon, { ...props, children: [_jsx("path", { d: "M1 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" }), _jsx("path", { d: "M10.605 2.107a10 10 0 1 1-8.038 13.225 1 1 0 0 1 1.886-.664 8 8 0 1 0 1.872-8.3l-4.64 4.36a1 1 0 1 1-1.37-1.457l4.63-4.35a10 10 0 0 1 5.66-2.814Z" })] }));
}
